
function TimoAdvantages() {
    return (
        <section className=" py-16">
            <div className="max-w-6xl mx-auto ">
                <h2 className="text-indigo-800 sm:text-4xl text-3xl font-semibold text-center mb-16">Vì sao bạn nên lựa chọn Timo</h2>

                <div className="grid lg:grid-cols-3 md:grid-cols-2 max-md:max-w-lg mx-auto gap-12">
                    <div
                        className="p-4 flex gap-6 border border-indigo-800 hover:shadow-md hover:scale-105 transition-all duration-300 mx-12 sm:mx-6 md:mx-4 xl:mx-2">

                        <div>
                            <h3 className="text-gray-800  tracking-tight text-lg font-medium mb-3">Chất lượng vải vượt trội </h3>
                            <p className="text-gray-600 font-OpenSans font-medium text-sm">Vải cao cấp, bền đẹp, chịu được giặt ủi nhiều lần.</p>
                        </div>
                    </div>

                    <div
                        className="p-4 flex gap-6 border border-indigo-800 hover:shadow-md hover:scale-105 transition-all duration-300 mx-12 sm:mx-6 md:mx-4 xl:mx-2">

                        <div>
                            <h3 className="text-gray-800 tracking-tight text-lg font-medium mb-3">Nguồn cung ổn định </h3>
                            <p className="text-gray-600 font-OpenSans font-medium text-sm">Kho dự trữ lớn, cam kết cung cấp vải kịp thời, ngay cả trong mùa cao điểm.</p>
                        </div>
                    </div>

                    <div
                        className="p-4 flex gap-6 border border-indigo-800 hover:shadow-md hover:scale-105 transition-all duration-300 mx-12 sm:mx-6 md:mx-4 xl:mx-2">

                        <div>
                            <h3 className="text-gray-800 tracking-tight text-lg font-medium mb-3">Giá cả cạnh tranh, Tối ưu chi phí</h3>
                            <p className="text-gray-600 font-OpenSans font-medium text-sm">Chính sách giá , giúp tối ưu chi phí mà vẫn đảm bảo chất lượng vượt trội</p>
                        </div>
                    </div>

                    <div
                        className="p-4 flex gap-6 border border-indigo-800 hover:shadow-md hover:scale-105 transition-all duration-300 mx-12 sm:mx-6 md:mx-4 xl:mx-2">

                        <div>
                            <h3 className="text-gray-800 tracking-tight text-lg font-medium mb-3">Hỗ trợ tận tâm, Hợp tác lâu dài</h3>
                            <p className="text-gray-600 font-OpenSans font-medium text-sm">Dịch vụ hỗ trợ chuyên nghiệp, cam kết hợp tác lâu dài.</p>
                        </div>
                    </div>

                    <div
                        className="p-4 flex gap-6 border border-indigo-800 hover:shadow-md hover:scale-105 transition-all duration-300 mx-12 sm:mx-6 md:mx-4 xl:mx-2">

                        <div>
                            <h3 className="text-gray-800 tracking-tight text-lg font-medium mb-3">Giao hàng nhanh chóng</h3>
                            <p className="text-gray-600 font-OpenSans font-medium text-sm">Cam kết giao hàng đúng hạn, nhanh chóng và linh hoạt trên toàn quốc.</p>
                        </div>
                    </div>

                    <div
                        className="p-4 flex gap-6 border border-indigo-800 hover:shadow-md hover:scale-105 transition-all duration-300 mx-12 sm:mx-6 md:mx-4 xl:mx-2">

                        <div>
                            <h3 className="text-gray-800 tracking-tight text-lg font-medium mb-3"> Hợp tác cùng nhiều thương hiệu lớn </h3>
                            <p className="text-gray-600 font-OpenSans font-medium text-sm">Đối tác tin cậy của nhiều thương hiệu lớn trong nước.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TimoAdvantages;
